import { render, staticRenderFns } from "./TextGlobalResponse.vue?vue&type=template&id=5b8f432e&"
import script from "./TextGlobalResponse.vue?vue&type=script&lang=js&"
export * from "./TextGlobalResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports